import React, { useEffect } from 'react';
import { SKELETON_LOADING_TIME } from '../../../utils/Constants';
import Card from "../../user/components/Card";
import { GetStreams } from '../../user/services/cms.service';
import { favouriteUnfavouriteStream } from '../../user/services/stream.service';
import { Link } from 'react-router-dom';
import { Placeholder } from 'rsuite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { formatDateAndTime, isUserLoggedIn, showLoginRequiredModal } from '../../../utils/commonfunction';
import Swal from 'sweetalert2';

export default function StreamsSection(props) {
    const [streams, setStreams] = React.useState([]);
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [currentTime, setCurrentTime] = React.useState(new Date());
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleLikeFavourite = async (item) => {
        try {
            const resp = await favouriteUnfavouriteStream(item._id);
            if (resp.success) {
                Swal.fire({
                    icon: 'success',
                    text: resp.message,
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                });

                setStreams(prev => prev.map(s => s._id === item._id ? { ...s, isFavouriteStream: !s.isFavouriteStream } : s));
            }
        } catch (error) {
            console.error("Failed to toggle favourite:", error);
        }
    };

    const handleViewStream = (item) => {
        const sellerId = item?.seller_id || item?.seller?._id || (typeof item?.seller === "string" ? item?.seller : undefined);
        if (!sellerId || !item?.room_id || !item?._id) {
            console.warn("Invalid stream data", item);
            return;
        }

        const targetUrl = `/user/live-streams/${sellerId}/${item.room_id}/${item._id}`;
        if (!isUserLoggedIn()) {
            showLoginRequiredModal({
                navigate,
                redirectUrl: targetUrl,
                text: t("common.login_required_to_view_stream", { defaultValue: "Please login to view stream details" }),
            });
            return;
        }

        navigate(targetUrl);
    };
    useEffect(() => {
        const typeQuery = props.type ? `&type=${props.type}` : "&type=live";

        GetStreams(`?per_page=4${typeQuery}`)
            .then((res) => {
                if (res.success) {
                    setStreams(res.data);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setTimeout(() => {
                    setDataLoaded(true);
                }, SKELETON_LOADING_TIME);
            });
    }, [props.type]);

    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 10000);
        return () => clearInterval(timer);
    }, []);

    return (
        <>
            <section className={props.className || "live-streaming-section bg-zinc-50 py-8 md:py-12 lg:py-24"}>
                <div className="container">
                    <div className="section-head flex justify-between items-center gap-[10px] mb-8 flex-wrap">
                        <h2 className="heading-web-h2 text-[var(--black-scale-900)]">
                            {props.title || t("home.heading_live_streams")}
                        </h2>
                        <Link to={`/user/live-streams?tab=${props.type || "live"}`} className="link">{t("home.btn_view_all")}</Link>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[30px]">
                        {dataLoaded ? (
                            streams.length > 0 ? (
                                streams.map((record, index) => {
                                    return (
                                        <div
                                            key={index}
                                        >
                                            <Card
                                                images={record.thumbnail}
                                                title={record.title}
                                                subtitle={record.description}
                                                time={record.duration}
                                                live={record.isLive}
                                                date={formatDateAndTime(record.date)}
                                                button={
                                                    props.type === "past"
                                                        ? "Rewatch"
                                                        : (props.type === "live" || new Date(record.date) <= currentTime)
                                                            ? "Watch Now"
                                                            : undefined
                                                }
                                                buttonDisabled={props.type === "past" && !record?.recording_url}
                                                onClick={() => {
                                                    const targetUrl = `/user/streams/stream-details/${record?._id}`;
                                                    if (!isUserLoggedIn()) {
                                                        showLoginRequiredModal({
                                                            navigate,
                                                            redirectUrl: targetUrl,
                                                            text: t("common.login_required_to_view_stream", { defaultValue: "Please login to view stream details" }),
                                                        });
                                                        return;
                                                    }
                                                    navigate(targetUrl);
                                                }}
                                                onButtonClick={() => handleViewStream(record)}
                                            />
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="col-span-full text-center py-10 text-gray-500 text-lg">
                                    {t("streams.no_streams_found", "No streams found")}
                                </div>
                            )
                        ) : (
                            Array(4)
                                .fill()
                                .map((_, i) => (
                                    <div key={i} className="w-full duration-300">
                                        <Placeholder.Graph
                                            className="w-full website-placeholder rounded-[16px]"
                                            active={true}
                                        />
                                    </div>
                                ))
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}